<template>
<div v-if="balanceInfo" class="tab-wrapper">
  <h3 class="mb16">结算信息</h3>
  <div class="content">
    <div class="item pt16 pb16">
      <h4 class="mb8">结算明细</h4>
      <table-list
      :current="current"
      :total="balanceInfo.total"
      :columns="balanceColums"
      @change-page="changPage"
      :data="balanceDetail"
      :loading="loading"></table-list>
    </div>
    <div class="item pt16 pb16">
      <h4 class="mb8">费用项结算汇总</h4>
      <table-list :showPage ="false" :columns="collectColums" :data="balanceInfo.totalCostItem" :loading="loading"></table-list>
    </div>
    <div class="bold">未核销账单汇总:{{balanceInfo.selectBillTotal}} </div>
    <div class="item pt16 pb16">
      <Row>
        <Col span="8">付款方：<span class="info">{{balanceInfo.payerName || ''}}</span></Col>
        <Col span="8">付款金额：<span class="info">{{balanceInfo.costAmount}}</span></Col>
      </Row>
    </div>
  </div>
  <div class="item pt16 pb16">
    <h4 class="mb8">{{`${balanceInfo.receivingName || ''}储存账户信息`}}</h4>
    <div class="table-wrap">
      <table class="ivu-table" cellspacing="0" cellpadding="0" border="0" >
        <thead>
          <tr>
            <th>开户行名称</th>
            <th>开户人名称</th>
            <th>银行账号</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="ivu-table-column-center">{{balanceInfo.bankName}}</td>
            <td class="ivu-table-column-center">{{balanceInfo.accountName}}</td>
            <td class="ivu-table-column-center">{{balanceInfo.bankAcount}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="item pt16 pb16">
    <h4 class="mb8">备注：</h4>
    <Input type="textarea" :disabled="true" :autosize="true" :value="balanceInfo.costRemark"></Input>
  </div>


  <div class="item pt16 pb16">
    <h4 class="mb8">{{balanceInfo.payerName==='甲方'?'付款信息':'收款信息'}} <span class="text-red" style="float: right">{{infoData.length?infoData[0]['balanceStatusName']:''}}</span></h4>

    <!--甲方-->
    <Table :columns="columnCase1" :data="infoData" class="mb8" v-if="balanceInfo.payerName==='甲方'"></Table>
    <!--乙方-->
    <Table :columns="columnCase2" :data="infoData" v-if="balanceInfo.payerName==='乙方'"></Table>

  </div>


  <balance-detail-modal :n="balanceDetailKey" :projectName="projectName"
                        :balanceInfo="houseBalanceInfo"
                        :roomNum="houseNumber"
                        :surrenderFid="surrenderFid"
                        v-if="surrenderFid"
                        :nocancelSurFid="nocancelSurFid"
  ></balance-detail-modal>
</div>


</template>

<script type="text/ecmascript-6">
import { getSurrenderCostItem, getEnterpriseBalance} from 'api/termination'
import defaultImg from '@/assets/filedefault.jpg'
import TableList from "components/TableList/index";
import BalanceDetailModal from "./BalanceDetailModal";
import {getSurrenderBalancePaymentsInfo} from "../../../../../api/contractList";
import {surrenderBalancePayment} from "../../../../../api/contractList";

export default {
  props:{
    projectName:{
      type:String,
      default:''

    },
    surrenderFid:{
      type:String,
      default:''
    },
    parentSurrenderFid:{
      type:String,
      default:''
    },
    contractFid:{
      type:String,
      default:''
    },
    n:{
      type:Number,
      default:0
    }
  },
  components:{
    TableList,
    BalanceDetailModal
  },
  created(){
    this.getBalanceInfo(1)
    this.getSurrenderBalancePaymentsInfo()
  },
  watch:{
    n(){
      this.getBalanceInfo(1)
      this.getSurrenderBalancePaymentsInfo()

    }
  },
  data () {
  return {
    nocancelSurFid:'',
    infoData:[],
    columnCase1:[
      {
        title: "付款单号",
        key: "billNum",
        align: "center"
      },
      {
        title: "提交时间",
        key: "submitTime",
        align: "center"
      },
      {
        title: "打款时间" ,
        key: "paymentTime",
        align: "center"
      },
      {
        title: "付款状态",
        key: "paymentStatusName",
        align: "center"
      },
      {
        title: "操作",
        key: "",
        align: "center",
        render:(h,params)=>{
          if(params.row['operateState']===1){
            return h('a',{
              on:{
                click:()=>{
                  this.$Modal.confirm({
                    title: '付款异常处理',
                    content: '<p>继续操作将重新生成付款单并执行打款流程，请问是否继续？</p>',
                    onOk: () => {
                      surrenderBalancePayment({busId: params.row['busId']}).then(res => {
                        this.$Message.success('操作成功')

                      }).catch(error => {

                      }).finally(() => {
                        this.getSurrenderBalancePaymentsInfo()
                      })
                    }
                  })

                }
              }
            },'重新付款')

          }
          else {
            return h('span',{},'')
          }

        }
      }


    ],
    columnCase2:[
      {
        title: "账单号",
        key: "billNum",
        align: "center"
      },
      {
        title: "提交时间",
        key: "submitTime",
        align: "center"
      },
      {
        title: "核销时间" ,
        key: "paymentTime",
        align: "center"
      },
      {
        title: "收款状态" ,
        key: "paymentStatusName",
        align: "center"
      },
      {
        title: "操作",
        key: "",
        align: "center"
      }
    ],
    houseNumber:'',
    balanceDetailKey:0,
    defaultImg:defaultImg,
    total:0,
    current:1,
    balanceDetail:[],
    balanceInfo:null,
    // balanceDetail:[],
    houseBalanceInfo:null,
    loading:true,
    subContractFid:'',
    balanceColums:[
      {
        title: "房间信息",
        key: "houseNumber",
        align: "center"

      },
      {
        title: "应缴总额",
        key: "receivableAmount",
        align: "center",
        render:(h,params)=>{
          return h('div',{
            style:{
              // width:'100px',
              textAlign:'right'
            }

          },params.row['receivableAmount'])
        },
      },
      {
        title: "已缴总额",
        key: "receivedAmount",
        align: "center",
        render:(h,params)=>{
          return h('div',{
            style:{
              // width:'100px',
              textAlign:'right'
            }

          },params.row['receivedAmount'])
        },
      },
      {
        title: "应退总额",
        key: "refundAmount",
        align: "center",
        render:(h,params)=>{
          return h('div',{
            style:{
              // width:'100px',
              textAlign:'right'
            }

          },params.row['refundAmount'])
        },
      },
      {
        title: "操作",
        key: "action",
        align: "center",
        render: (h,params) => {
          return h('span',{
            style:{
              color: '#CFA868',
              cursor: 'pointer'
            },
            on: {
              click: ()=>{
                this.houseNumber = params.row.houseNumber
                this.subContractFid = params.row.contractFid
                const  balanceParams= {
                  contractFid:this.subContractFid
                }
                getSurrenderCostItem(balanceParams).then( res => {
                  this.houseBalanceInfo = res.data.totalCostItem
                })
                this.nocancelSurFid=params.row['surrenderFid']
                this.balanceDetailKey++
              }
            }
          },'查看')
        }
      }
    ],
    balanceList:[{
      roomInfo:'301'
    }],
    collectColums:[
      {
        title: "费用项",
        key: "expenseItemName",
        align: "center"
      },
      {
        title: "应缴费用",
        key: "receivableAmount",
        align: "center",
        render:(h,params)=>{
          return h('div',{
            style:{
              // width:'100px',
              textAlign:'right'
            }

          },params.row['receivableAmount'])
        },

      },
      {
        title: "已缴费用",
        key: "receivedAmount",
        align: "center",
        render:(h,params)=>{
          return h('div',{
            style:{
              // width:'100px',
              textAlign:'right'
            }

          },params.row['receivedAmount'])
        },
      },
      {
        title: "应退费用",
        key: "refundAmount",
        align: "center",
        render:(h,params)=>{
          return h('div',{
            style:{
              // width:'100px',
              textAlign:'right'
            }

          },params.row['refundAmount'])
        },
      },
      {
        title: "实退费用",
        key: "actRefundAmount",
        align: "center",
        render:(h,params)=>{
          return h('div',{
            style:{
              // width:'100px',
              textAlign:'right'
            }

          },params.row['actRefundAmount'])
        },
      },
    ],
    collectList:[]

  };
 },
  methods:{
    getSurrenderBalancePaymentsInfo(){
      const params={
        surrenderFid:this.parentSurrenderFid
      }
      getSurrenderBalancePaymentsInfo(params).then(res=>{
        if(!res.data){
          return
        }
        this.infoData=res.data

      }).catch(error=>{

      })

    },
    changPage(n){
      this.current = n;
      this.getBalanceInfo(n)
    },
    getBalanceInfo(page){
      // this.loading = true
      const params = {
        page:page,
        limit:10,
        surrenderFid:this.surrenderFid,
        parentSurrenderFid:this.parentSurrenderFid,
        contractFid:this.contractFid
      }
      getEnterpriseBalance(params).then( res => {
        this.balanceInfo = res.data
        this.balanceDetail = this.balanceInfo.surrenderBanlances
        this.loading = false
      })
    }
 }
}
</script>

<style scoped>
.info {
  padding-left: 8px;
  font-weight: 600;
}
.table-wrap {
  position: relative;
  border: 1px solid #dddee1;
    border-bottom: 0;
    border-right: 0;
}
table {
  width: 100%;
}
th,td {
  text-align: center;
}
</style>



